import { useState, useRef, useEffect } from "react";

const COLORS = [
  { name: "Negro", value: "#000000" },
  { name: "Blanco", value: "#FFFFFF" },
  { name: "Rojo", value: "#FF0000" },
  { name: "Azul", value: "#0000FF" },
  { name: "Verde", value: "#008000" },
  { name: "Amarillo", value: "#FFFF00" },
  { name: "Naranja", value: "#FFA500" },
];

export const ColorPickerDropdown = ({ editor }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Hook SIEMPRE arriba, nunca después de un return
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Ahora sí: si no hay editor, devolvés null DESPUÉS de los hooks
  if (!editor) return null;

  const currentColor = editor.getAttributes("textStyle")?.color || "";

  return (
    <div style={{ position: "relative" }} ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          padding: "4px 8px",
          cursor: "pointer",
          borderRadius: "4px",
          border: "1px solid #ccc",
          background: "#f7f7f7",
        }}
      >
        🎨 Color
      </button>

      {open && (
        <div
          style={{
            position: "absolute",
            top: "36px",
            left: 0,
            background: "white",
            border: "1px solid #ccc",
            borderRadius: "8px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            padding: "12px",
            display: "grid",
            gridTemplateColumns: "repeat(4, 24px)",
            gap: "10px",
            zIndex: 999,
          }}
        >
          {COLORS.map((c) => (
            <button
              key={c.value}
              onClick={() => {
                editor.chain().focus().setColor(c.value).run();
                setOpen(false);
              }}
              title={c.name}
              style={{
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                backgroundColor: c.value,
                border:
                  currentColor === c.value
                    ? "3px solid #555"
                    : "1px solid #ccc",
                cursor: "pointer",
              }}
            />
          ))}

          <button
            onClick={() => {
              editor.chain().focus().unsetColor().run();
              setOpen(false);
            }}
            style={{
              gridColumn: "span 4",
              padding: "4px 6px",
              fontSize: "12px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              cursor: "pointer",
              background: "#f5f5f5",
            }}
          >
            Predeterminado
          </button>
        </div>
      )}
    </div>
  );
};
